import {
  AutocompleteAddressByPinQuery,
  AutocompleteAddressByPinQueryVariables,
} from '@amzn/ring-neighbors-api-orchestrator-gql-schema';
import GET_LOCATIONS from '@amzn/ring-neighbors-api-orchestrator-gql-schema/operations/authenticated/location/autocompleteAddressByPin.graphql';
import { useApolloClient } from '@apollo/client';
import { useRef } from 'react';
import { useAlertAreaState } from 'src/context';

export const useGetLocationAutocompleteOptions = () => {
  const { selectedAlertArea } = useAlertAreaState();
  const tokenRef = useRef<string | null>(null);
  const client = useApolloClient();

  const {
    preferences: { radius_in_meters: radius },
    location: {
      pin: { latitude, longitude },
    },
  } = selectedAlertArea!;

  const getOptions = async (address: string) => {
    const { data, errors } = await client.query<
      AutocompleteAddressByPinQuery,
      AutocompleteAddressByPinQueryVariables
    >({
      query: GET_LOCATIONS,
      variables: {
        address,
        latitude,
        longitude,
        radius,
        ...(tokenRef.current && {
          session_token: tokenRef.current,
        }),
      },
    });

    const { session_token } = data.locationAutoCompleteByPinPreference!;

    tokenRef.current = session_token;

    return { data, errors };
  };

  return getOptions;
};
